module.exports = __webpack_public_path__ + "img/lurk.3e6c4b0f.gif";